module.exports = __webpack_public_path__ + "static/media/dot-selected.424d6a66.png";